var render = function () {
  var _vm$user, _vm$user$createdAt, _vm$user$createdAt$to;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm.user._id ? _c('span', [_vm._v("회원 상세보기")]) : _c('span', [_vm._v("회원 등록")])]), _c('v-card', {
    staticClass: "my-4"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("계정")]), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "아이디",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: _vm.user.username,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "username", $$v);
      },
      expression: "user.username"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [(_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user._id ? _c('v-text-field', {
    attrs: {
      "value": (_vm$user$createdAt = _vm.user.createdAt) === null || _vm$user$createdAt === void 0 ? void 0 : (_vm$user$createdAt$to = _vm$user$createdAt.toDateTime) === null || _vm$user$createdAt$to === void 0 ? void 0 : _vm$user$createdAt$to.call(_vm$user$createdAt),
      "label": "가입일시",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    }
  }) : _vm._e()], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "비밀번호",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.password,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "password", $$v);
      },
      expression: "user.password"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  })], 1), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("기본 정보")]), _c('v-divider'), _vm.user.type == _vm.PERSON.value ? [_c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이름",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "date",
      "max": "2999-12-31",
      "label": "생년월일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.bornAt,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "bornAt", $$v);
      },
      expression: "user.bornAt"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "성별",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.gender,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "gender", $$v);
      },
      expression: "user.gender"
    }
  })], 1)], 1)] : _vm._e(), _vm.user.type == _vm.COMPANY.value ? [_c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기업명",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.name,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "name", $$v);
      },
      expression: "user.name"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "대표자명",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.ceoName,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "ceoName", $$v);
      },
      expression: "user.ceoName"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "홈페이지주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.website,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "website", $$v);
      },
      expression: "user.website"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "append",
      "small": "",
      "text": "",
      "icon": "",
      "href": _vm.user.website,
      "target": "_blank"
    },
    slot: "append"
  }, [_c('v-icon', [_vm._v("mdi-link")])], 1)], 1)], 1)], 1)] : _vm._e(), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("연락처")]), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "phone", $$v);
      },
      expression: "user.phone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.email,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "email", $$v);
      },
      expression: "user.email"
    }
  })], 1)], 1), _c('v-divider'), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.DaumPostcode.open();
      }
    },
    model: {
      value: _vm.user.postcode,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "postcode", $$v);
      },
      expression: "user.postcode"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기본주소",
      "persistent-placeholder": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.DaumPostcode.open();
      }
    },
    model: {
      value: _vm.user.address1,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address1", $$v);
      },
      expression: "user.address1"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "상세주소",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.address2,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "address2", $$v);
      },
      expression: "user.address2"
    }
  })], 1)], 1), _c('daum-postcode', {
    ref: "DaumPostcode",
    on: {
      "input": _vm.setAddress
    }
  })], 2), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-divider', {
    staticClass: "d-block d-md-none"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_vm.user.type == _vm.COMPANY.value ? [_c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("로고")]), _c('v-divider'), _c('image-input', {
    attrs: {
      "contain": "",
      "flat": "",
      "tile": "",
      "aspect-ratio": 3 / 1
    },
    model: {
      value: _vm.user.logo,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "logo", $$v);
      },
      expression: "user.logo"
    }
  }), _c('v-divider'), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("사업자등록증")]), _c('v-divider'), _c('image-input', {
    attrs: {
      "contain": "",
      "flat": "",
      "tile": "",
      "aspect-ratio": 3 / 2
    },
    model: {
      value: _vm.user.businessRegistration,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "businessRegistration", $$v);
      },
      expression: "user.businessRegistration"
    }
  }), _c('v-divider')] : _vm._e(), _vm.user.type == _vm.PERSON.value ? [_c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("프로필")]), _c('v-divider'), _c('image-input', {
    attrs: {
      "contain": "",
      "flat": "",
      "tile": "",
      "aspect-ratio": 1 / 1
    },
    model: {
      value: _vm.user.profile,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "profile", $$v);
      },
      expression: "user.profile"
    }
  }), _c('v-divider')] : _vm._e(), _c('v-card-subtitle', {
    staticClass: "font-weight-bold grey lighten-4"
  }, [_vm._v("관리자메모")]), _c('v-divider'), _c('v-card-text', [_c('v-textarea', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "hide-details": "",
      "auto-grow": ""
    },
    model: {
      value: _vm.user.note,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "note", $$v);
      },
      expression: "user.note"
    }
  })], 1)], 2)], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "align-center grey lighten-4"
  }, [_c('v-switch', {
    staticClass: "my-0 mx-4 pa-0",
    attrs: {
      "color": "red lighten-1",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.isWarning,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isWarning", $$v);
      },
      expression: "user.isWarning"
    }
  }, [_c('span', {
    staticClass: "subtitle-2 font-weight-bold",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" 주의회원 ")])]), _c('v-switch', {
    staticClass: "my-0 mx-4 pa-0",
    attrs: {
      "color": "red lighten-1",
      "dense": "",
      "inset": "",
      "hide-details": ""
    },
    model: {
      value: _vm.user.isApproved,
      callback: function callback($$v) {
        _vm.$set(_vm.user, "isApproved", $$v);
      },
      expression: "user.isApproved"
    }
  }, [_c('span', {
    staticClass: "subtitle-2 font-weight-bold",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(" 회원승인 ")])]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")]), _c('user-withdraw', {
    on: {
      "input": function input($event) {
        return _vm.$router.go(-1);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-2",
          attrs: {
            "color": "red darken-1",
            "dark": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v("탈퇴")])];
      }
    }]),
    model: {
      value: _vm.user,
      callback: function callback($$v) {
        _vm.user = $$v;
      },
      expression: "user"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }